var map = {
	"./adminprofile/edit": [
		2000,
		16
	],
	"./agentprofile/edit": [
		2001,
		19
	],
	"./ai_assistant/edit": [
		2002,
		22
	],
	"./api_key/edit": [
		2003,
		25
	],
	"./canned_answer/edit": [
		2004,
		30
	],
	"./client/edit": [
		2005,
		33
	],
	"./destination_restrictor/edit": [
		2006,
		35
	],
	"./disposition/edit": [
		2007,
		38
	],
	"./field/edit": [
		2008,
		41
	],
	"./form/edit": [
		2009,
		44
	],
	"./form_website/edit": [
		2010,
		47
	],
	"./gdpr/edit": [
		2011,
		49
	],
	"./invoice/edit": [
		2012,
		51
	],
	"./invoice_post/edit": [
		2013,
		54
	],
	"./journey/edit": [
		2014,
		57
	],
	"./journey_draft/edit": [
		2015,
		60
	],
	"./journey_variable/edit": [
		2016,
		64
	],
	"./list/edit": [
		2017,
		67
	],
	"./list_file/edit": [
		2018,
		70
	],
	"./mail_account/edit": [
		2019,
		73
	],
	"./operational_hours/edit": [
		2020,
		76
	],
	"./organization/edit": [
		2021,
		79
	],
	"./pause/edit": [
		2022,
		82
	],
	"./phonenumber_monthly_cost/edit": [
		2023,
		85
	],
	"./phonenumber_monthly_cost_parent/edit": [
		2024,
		88
	],
	"./phonenumber_purchase/edit": [
		2025,
		92
	],
	"./phonenumber_setup_cost/edit": [
		2026,
		95
	],
	"./phonenumber_setup_cost_parent/edit": [
		2027,
		98
	],
	"./points_system/edit": [
		2028,
		102
	],
	"./prepaid_credit/edit": [
		2029,
		105
	],
	"./queue/edit": [
		2030,
		108
	],
	"./signature/edit": [
		2031,
		112
	],
	"./skill/edit": [
		2032,
		115
	],
	"./sla_policy/edit": [
		2033,
		118
	],
	"./sound/edit": [
		2034,
		121
	],
	"./stats_alarm/edit": [
		2035,
		124
	],
	"./stats_custom_metric/edit": [
		2036,
		127
	],
	"./stats_report/edit": [
		2037,
		130
	],
	"./stats_widget/edit": [
		2038,
		133
	],
	"./superadmin_profile/edit": [
		2039,
		136
	],
	"./tag/edit": [
		2040,
		139
	],
	"./tariff/edit": [
		2041,
		142
	],
	"./tariff_parent/edit": [
		2042,
		145
	],
	"./team/edit": [
		2043,
		148
	],
	"./text_message_source/edit": [
		2044,
		6
	],
	"./time_interval/edit": [
		2045,
		152
	],
	"./user/edit": [
		2046,
		155
	],
	"./voice_asterisk/edit": [
		2047,
		158
	],
	"./voice_asterisk_downgrade/edit": [
		2048,
		161
	],
	"./voice_recording_transcript_setting/edit": [
		2049,
		165
	],
	"./voice_route/edit": [
		2050,
		168
	],
	"./voice_shortcut/edit": [
		2051,
		171
	],
	"./voice_trunk/edit": [
		2052,
		174
	],
	"./voice_voicemail/edit": [
		2053,
		177
	],
	"./wallboard/edit": [
		2054,
		180
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1872;
module.exports = webpackAsyncContext;